export default __webpack_public_path__ + "images/c3a42737343b2e2a824d51c20dfe905e-valentine_dsrp_desktop.webp";